import CreateExchangeForm from './ui/CreateExchangeForm/CreateExchangeForm.css';
export default {
    CreateExchangeForm
};
